import { useTranslations } from 'next-intl';
import { useAtomValue, useSetAtom } from 'jotai';

import { useSiteStore } from '@/store/site';
import { oddsLeaguesForFilterAtom, saveLeagueSelectionAtom } from '@/atoms/league-filter';
import { itemsEmptyCheck } from '@nf/utils-common/fpw/utils';
import { uiService } from '@/services/ui.service';
import { useLeagueFilter } from '@/features/league-filter/hooks/use-league-filter';

import { Button } from '@nf/ui';

export const LeagueFilterFooter = () => {
	const t = useTranslations('General');
	const [setFilterLeagues] = useSiteStore(
		state => [state.setFilterLeagues],
	);
	const oddsLeagues = useAtomValue(oddsLeaguesForFilterAtom);
	const saveLeagueSelection = useSetAtom(saveLeagueSelectionAtom);
	const { tempLeagueSelection } = useLeagueFilter();

	const handleComplete = () => {
		itemsEmptyCheck(tempLeagueSelection)
			.fold(
				() => {},
				() => {
					// select all 時應當清除所有篩選條件, 而非真的將當下的league id保存起來, 否則下次用戶進來時可能會沒有任何match可看
					const selectedLeagueIds = tempLeagueSelection.length !== oddsLeagues.size ? 
						tempLeagueSelection.map(leagueItem => leagueItem.leagueId) : [];
					const selectedLeagueIdsSet = new Set(selectedLeagueIds);
					saveLeagueSelection({
						leagueSet: selectedLeagueIdsSet
					});
					setFilterLeagues([...selectedLeagueIdsSet]);

					uiService.displayLeagueFilter(false);
				}
			);
	};

	return (
		<div className="select-league__footer">
			<Button 
				shape="capsule"
				data-disabled={tempLeagueSelection.length === 0}
				onClick={handleComplete}
			>
				{t('lbl_Done')}
			</Button>
		</div>
	);
};